document.addEventListener('DOMContentLoaded', () => {
  // Crear elementos del modal
  const modalOverlay = document.createElement('div');
  modalOverlay.classList.add('cart-modal-overlay');
  
  const cartModal = document.createElement('div');
  cartModal.classList.add('cart-modal');
  cartModal.innerHTML = `
    <button class="cart-modal-close">&times;</button>
    <div class="cart-modal-content">
      <h2 class="cart-modal-title">Producto añadido al carrito</h2>
      <div class="cart-modal-product"></div>
      <div class="cart-modal-actions">
        <button class="btn-checkout">PAGAR PEDIDO</button>
      </div>
    </div>
  `;

  document.body.appendChild(modalOverlay);
  document.body.appendChild(cartModal);

  // Seleccionar elementos
  const productContainer = cartModal.querySelector('.cart-modal-product');
  const closeButton = cartModal.querySelector('.cart-modal-close');
  const checkoutButton = cartModal.querySelector('.btn-checkout');

  // Función para abrir modal
  function openCartModal(item, size) {
    const formattedPrice = (item.price / 100).toFixed(2); // Convertir a formato decimal

    // Verificar que el talle esté presente y asignarlo correctamente
    const productSize = size || 'No especificado'; // Si el talle no está definido, mostrar 'No especificado'

    // Modificar el HTML para asegurar que el talle y el precio estén en su propia línea
    productContainer.innerHTML = `
      <img src="${item.image}" alt="${item.title}">
      <div>
        <h3>
          ${item.title}
        </h3>
        <p><strong>Talle:</strong> <span class="product-size">${productSize}</span></p>
        <p><strong>Precio:</strong> <span class="product-price">$${formattedPrice}</span></p>
      </div>
    `;
    
    cartModal.classList.add('open');
    modalOverlay.classList.add('visible');
  }

  // Función para cerrar modal
  function closeCartModal() {
    cartModal.classList.remove('open');
    modalOverlay.classList.remove('visible');
  }

  // Eventos de botones
  closeButton.addEventListener('click', closeCartModal);
  modalOverlay.addEventListener('click', closeCartModal);

  checkoutButton.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  // Interceptar formularios de agregar al carrito
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      // Obtener el valor del talle desde el formulario
      const size = form.querySelector('[name="size"]') ? form.querySelector('[name="size"]').value : 'No especificado';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(response => response.json())
      .then(item => {
        // Asignar el talle y luego abrir el modal
        item.size = size; // Asignar el tamaño al producto
        openCartModal(item, size); // Pasar el talle como argumento
      })
      .catch(error => {
        console.error('Error al agregar producto:', error);
      });
    });
  });
});
